import validate from "/home/runner/work/jw-app/jw-app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _00_45fetch_45urlmetadata_45global from "/home/runner/work/jw-app/jw-app/src/nuxtMiddleware/00.fetch-urlmetadata.global.ts";
import setup_45routing_45middleware_45global from "/home/runner/work/jw-app/jw-app/src/nuxtMiddleware/setupRoutingMiddleware.global.ts";
import manifest_45route_45rule from "/home/runner/work/jw-app/jw-app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  _00_45fetch_45urlmetadata_45global,
  setup_45routing_45middleware_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "before-enter-subgenres": () => import("/home/runner/work/jw-app/jw-app/src/nuxtMiddleware/before-enter-subgenres.ts")
}